import allProducts from './allProducts';

export default function getProduct(handle: string) {
  const products = allProducts();
  for (const p of products) {
    if (p.handle === handle) {
      return p;
    }
  }
  throw new Error('Unknown Product Handle ' + handle);
}
